(function (namespace, $) {
    "use strict";

    var AppChat = function () {
        var o = this;

        jQuery(document).ready(function () {
            o.initialize();
        });

    };

    var p = AppChat.prototype;

    p._timeout;
    p._unread;
    p._vehicles;
    p._timeoutNewMessages;
    p.initialize = function () {
        var o = this;

        o._timeout = null;
        o._unread = 0;
        o._vehicles = [];
        o._timeoutNewMessages = null;

        jQuery('body').delegate('.chat-message-send', 'click', function () {
            var id = jQuery(this).closest('.chat-card').attr('data-id');
            var message = jQuery('#chat-' + id + ' .chat-message-input').val();
            o.saveMessage(id, message);
        });

        jQuery('body').delegate('.chat-card-close a', 'click', function () {
            var chat = jQuery(this).closest('.chat-card');
            chat.hide();
        });

        jQuery('body').delegate('.popover-chat-message, .icon-chat-message', 'click', function () {
            var id = jQuery(this).attr('data-id');
            o._openChat(id);
        });

        jQuery('body').delegate('.popover-chat-content', 'click', function () {
            jQuery('.popover-chat').popover('hide');
            jQuery('.popover-chat-content').hide();
        });

        jQuery('body').delegate('.chat-card', 'mousedown', function () {
            var zIndex = 0;
            jQuery('.chat-card').each(function () {
                var e = jQuery(this);
                if (e.is(':visible') && parseInt(e.css("zIndex")) > zIndex) {
                    zIndex = parseInt(e.css("zIndex"));
                }
            });
            jQuery(this).css('zIndex', zIndex + 1);
        });

        jQuery('#button-message-menu').on('click', function (e) {
            e.preventDefault();
            o._getMessagesMenu();

        });

        jQuery(document).on('click', '#open-chat', function () {
            o._openChat(jQuery(this).attr('data-id'));
        });

        jQuery(document).on('click', '#mark-read', function () {
            var ids = jQuery(this).attr('data-ids').split(',');
            var badge = jQuery(this).attr('data-badge');
            let messageIconId = $(this).attr('data-message-icon-id');
            let messageIconEl = $(`#${messageIconId}`);
            messageIconEl.attr('class', 'icon-IconBMessagesOpen-24');

            for (var i in ids) {
                o.setMessageRead(ids[i]);
            }

            jQuery('#badge' + badge).remove();
            jQuery(this).remove();
            gpssat.AppAlert._getNumberAlerts();
        });

        jQuery(document).on('click', '#historic-chat', function () {

            window.gpssat.AppPage._openPageAjax('vehicles/' + jQuery(this).attr('data-id') + '/historic', 17, null, true);

        });
    };

    p._getMessagesMenu = function () {
        var o = this;

        window.gpssat.App._ajax('GET', window.location.origin + "/messages/text/messagesMenu", false,
            function (data) {
                jQuery('#offcanvas-message-left .offcanvas-body').html(data.html);
                window.gpssat.AppOffcanvas._handleOffcanvasOpen(jQuery(this).attr('href', '#offcanvas-message-left'));
            },
            function (data) {
                o.alerts._error(Lang.get('error-support'));
            }
        );

    };

    p._openChat = function (id) {

        var o = gpssat.AppChat;

        if (jQuery('#chat-' + id).length) {
            jQuery('#chat-' + id).show();

            if (o._timeout === null) {
                o._timeout = setTimeout(function () {
                    o.refreshMessages(id);
                }, 1000);
            }

        } else {
            var data = {
                _token: jQuery('[name=csrf-token]').attr('content'),
                vehicle_id: id,
            };
            window.gpssat.App._ajax('POST', window.location.origin + '/operations/control/panel/chat', data,
                function (data) {
                    jQuery('#content-page').append(data.html);
                    jQuery(function () {
                        jQuery("#chat-" + id).draggable({ handle: ".card-head" });
                    });

                    if (o._timeout === null) {
                        o._timeout = setTimeout(function () {
                            o.refreshMessages(id);
                        }, 1000);
                    }
                },
                function (response) {
                    window.gpssat.AppMessage._error(response.msg);
                },
                false
            );
        }
    };

    p.saveMessage = function (id, message) {
        if (message.length > 0 && message.length < 141 && id != 0) {
            jQuery('#chat-' + id + ' .chat-message-input').val('');
            var data = {
                _token: jQuery('[name=csrf-token]').attr('content'),
                vehicle_id: id,
                message: message
            };
            window.gpssat.App._ajax('POST', window.location.origin + '/operations/control/panel/saveMessage', data,
                function () {
                },
                function (response) {
                    window.gpssat.AppMessage._error(response.msg);
                },
                false
            );
        }
    };

    p.refreshMessages = function (first) {

        var o = gpssat.AppChat;

        var vehicles = [];

        jQuery('.chat-card').each(function (index) {
            if (jQuery(this).is(':visible')) {
                vehicles[index] = jQuery(this).attr('data-id');
            }
        });

        if (vehicles.length) {
            window.gpssat.App._ajax('GET', window.location.origin + '/operations/control/panel/getMessages', { vehicles: vehicles },
                function (response) {
                    for (var i = 0; i < vehicles.length; i++) {
                        if (response.messages[vehicles[i]] != null) {
                            o.populateMessages(vehicles[i], response.messages[vehicles[i]], response.operator_id);

                            if (first) {
                                o.scrollTop(first, 0);
                            }
                        }
                    }
                    clearTimeout(o._timeout);
                    o._timeout = setTimeout(function () {
                        o.refreshMessages(false);
                    }, 2000);
                },
                function (response) {
                    clearTimeout(o._timeout);
                    o._timeout = setTimeout(function () {
                        o.refreshMessages(false);
                    }, 2000);
                }, false
            );
        } else {
            clearTimeout(o._timeout);
            o._timeout = null;
        }
    };

    p.populateMessages = function (id, messages, operator_id) {
        var o = this;
        var unread = 0;
        var html = '';
        for (var i = 0; i < messages.length; i++) {
            html += "<div class='chat-message-" + messages[i].message_id + " message wrapper-content";
            if (operator_id === messages[i].operator_id) {
                html += " user";
            } else if (!messages[i].to_terminal) {
                html += " operator";
            }
            html += "' data-id='" + messages[i].message_id + "'>";
            html += "<div class='name'>";
            html += messages[i].operator_name;
            html += "</div>";
            html += "<div class='text'>";
            html += messages[i].message;
            html += "</div>";
            html += "<div class='bottom'>";

            if (messages[i].status === 5) {
                html += "<div class='md md-info-outline' " +
                    "title='Falha ao enviar a mensagem'></div>";
            } else if (messages[i].status === 4) {
                html += "<div class='fa fa-check' title='" + Lang.get('operational_panel.message_read') + "'></div>";
            } else if (messages[i].status === 3) {
                html += "<div class='fa fa-check unread' title='" + Lang.get('operational_panel.message_sent_successfully') + "'></div>";
            } else {
                html += "<div class='md md-schedule unread' title='" + Lang.get('operational_panel.sending_message') + "'></div>";
            }
            html += "<div class='date'>";
            html += messages[i].msg_date_desc;
            html += "</div>";
            html += "</div>";
            html += "</div>";

            if (messages[i].operator_read === null) {
                o.setMessageRead(messages[i].message_id);
                if (unread < messages[i].message_id) {
                    unread = messages[i].message_id;
                }
            }
        }

        jQuery('#chat-' + id + ' .chat-content').html(html);

        if (o._unread != unread) {
            o._unread = unread;
            o.scrollTop(id, unread);
            gpssat.AppAlert._getNumberAlerts();
        }
    };

    p.scrollTop = function (id, messageId) {
        var container = jQuery('#chat-' + id + ' .chat-content');
        var position = container[0].scrollHeight;
        if (messageId != 0) {
            var e = jQuery('#chat-' + id + ' .chat-message-' + messageId);
            position = e.offset().top - container.offset().top + container.scrollTop() - 8;
        }
        container.animate({
            scrollTop: position
        }, 500);
    };

    p.setMessageRead = function (id) {
        var data = {
            _token: jQuery('[name=csrf-token]').attr('content'),
            text_id: id
        };
        window.gpssat.App._ajax('POST', window.location.origin + '/operations/control/panel/setMessageRead',
            data,
            function () { //SUCESSO
            },
            function () { //ERRO
            },
            false
        );
    };

    p.getPopoverCustomTemplate = function (className) {
        return '<div class="popover ' + className + '" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>';
    };

    p._getNewMessages = function () {
        var o = this;

        jQuery('.popover-chat').popover({
            html: true,
            container: 'body',
            content: '',
            template: o.getPopoverCustomTemplate('popover-chat-content')
        });

        jQuery('#chat-number').html('');

        jQuery('.popover-chat').popover('hide');

        jQuery('.popover-chat').data('bs.popover').options.content = '';

        o._timeoutNewMessages = setTimeout(function () {
            o.refreshNewMessages();
        }, 500);
    };

    p.refreshNewMessages = function () {
        var o = this;

        if (o._vehicles.length < 1 || !jQuery('.popover-chat').length) {
            jQuery('.popover-chat-content').popover('hide');
            clearTimeout(o._timeoutNewMessages);
            return;
        }

        window.gpssat.App._ajax('GET', window.location.origin + '/operations/control/panel/getNewMessages', { vehicles: o._vehicles.toString() },
            function (response) {
                o.populatePopover(response.messages);
                clearTimeout(o._timeoutNewMessages);
                o._timeoutNewMessages = setTimeout(function () {
                    o.refreshNewMessages();
                }, 10000);
            },
            function (response) {
                clearTimeout(o._timeoutNewMessages);
                o._timeoutNewMessages = setTimeout(function () {
                    o.refreshNewMessages();
                }, 10000);
            }, false
        );
    };

    p.populatePopover = function (messages) {
        var o = this;
        var contentHtml = "";
        var vehicle = [];
        var unread = 0;
        var unreadTotal = 0;
        var j = -1;

        for (var i = 0; i < messages.length; i++) {

            if (vehicle.length < 1 || vehicle[j].id != messages[i].vehicle_id) {
                vehicle.push({
                    id: messages[i].vehicle_id,
                    name: messages[i].vehicle_name,
                    date: messages[i].msg_date_desc,
                    unread: 0,
                });

                if (j >= 0) {
                    vehicle[j].unread = unread;
                    unreadTotal += unread;
                }

                unread = 0;
                j++;
            }

            if (messages[i].operator_read === null) {
                unread++;
            }
        }

        if (j >= 0) {
            vehicle[j].unread = unread;
            unreadTotal += unread;
        }

        for (var i = 0; i < vehicle.length; i++) {
            contentHtml += "<div class='col-md-12 popover-chat-message' style='cursor: pointer' data-id='" + vehicle[i].id + "'>";
            contentHtml += "<div class='name' style='width: 90%;display: inline-block'>";
            contentHtml += vehicle[i].name;
            contentHtml += "</div>";
            contentHtml += "<div class='name' style='width: 10%;display: inline-block'>";
            contentHtml += vehicle[i].unread;
            contentHtml += "</div>";
            contentHtml += "</div>";
        }

        if (unreadTotal > 0) {
            jQuery('#chat-number').html(unreadTotal);
        }
        else {
            jQuery('#chat-number').html('');
        }

        jQuery('.popover-chat').data('bs.popover').options.content = contentHtml;

    };

    window.gpssat.AppChat = new AppChat;
}(window.gpssat, jQuery));